import { GlobalState } from 'little-state-machine';

export function setLeadListCreate(state: GlobalState, payload: GlobalState['leadListCreate']) {
  return {
    ...state,
    leadListCreate: {
      ...state.leadListCreate,
      ...payload,
    },
  };
}

export function clearLeadListCreate(state: GlobalState) {
  return {
    ...state,
    leadListCreate: {},
  };
}
